<template>
  <div v-if="isShowAnkenInfo">
    <div class="data-content-anken" v-for="data in tableData" :key="data.id">
        <div class="anken-info">
            <i class="el-icon-info" style="padding-bottom: 1em; font-size: 20px">{{ data.ankenName }}</i>
            <div class="table-responsive">
                <table class="table m-0 table-result" :class="{ el_table_mobile: isMobile}" width="100%">
                    <thead>
                    <tr>
                        <th width="20%">利用者</th>
                        <th width="20%">相続発生日</th>
                        <th width="20%">申告期限</th>
                        <th width="20%">スケジュール</th>
                        <th width="20%">最終更新日</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in Array.of(data)" :key="index" :value="index">
                        <td>
                            <div class="d-inline-block">
                                <div class="text-left" v-for="heir in row.heirs" :key="heir.id">
                                    {{(getMemberName(heir))}}
                                </div>
                            </div>
                        </td>
                        <td>
                            <label v-text="formatDate(row.sozokuStartDate)"></label>
                        </td>
                        <td>
                            <label v-text="formatDate(row.shinkokuEndDate)"></label>
                        </td>
                        <td>
                            <div class="div-update-notice">
                            <router-link :to="'/document/' + row.id" class="link-to-document"
                                         v-if="row.scheduleFileName !== null">
                                 <img height="12px" src="@/images/new.png" :class="noticeSchedule[data.id] ? 'img-update-notice-schedule': 'img-update-notice-none'">
                                 <label @click="scrollFile(row.id)">
                                    相続税申告スケジュール
                                  </label>
                            </router-link>
                            </div>
                        </td>
                        <td class="vertical-align-middle">
                            <label v-text="formatDate(row.updatedAt)"></label>
                        </td>
                    </tr>
                    <tr>
                        <td style="text-align: left !important; width: inherit; border-top: 2px solid #d6d6d6;"
                            colspan="5">
                            <div v-show="isMobile && (isPortal || isAnken)">
                              <li><a style="color: #3a8ee6" href="#explanation" @click="handleShowExplanation">以下の機能説明はコチラ</a></li><br>
                            </div>
                            <div class="btn-list flex" style="margin-top: unset !important;" v-if="!isHideButton">
                                <div class="div-update-notice">
                                    <router-link v-bind:to="'/invoiceFlag/' + data.id">
                                        <img height="12px" src="@/images/new.png"
                                             :class="noticeInvoiceFlag[data.id] ? 'img-update-notice': 'img-update-notice-none'">
                                        <el-popover
                                            placement="top-start"
                                            title=""
                                            width="200"
                                            trigger="hover"
                                            content="相続の際に必要となる手続きを一覧にまとめました。"
                                            transition="el-zoom-in-bottom"
                                            popper-class="anken-tooltip"
                                            visible-arrow="false">
                                            <el-button class="btn button-color btn-table gtm_ankenmember_checklist_m"
                                                       :class="isMobile ? 'el_mobile_button_left': ''" slot="reference">
                                                <span class="gtm_ankenmember_checklist_m">相続手続き<br/>チェックリスト</span>
                                            </el-button>
                                        </el-popover>
                                    </router-link>

                                </div>
                                <div class="div-update-notice">
                                    <router-link v-bind:to="'/camera/' + data.id">
                                        <img height="12px" src="@/images/new.png"
                                             :class="noticeCamera[data.id] ? 'img-update-notice': 'img-update-notice-none'">
                                        <el-popover
                                            placement="top-start"
                                            title=""
                                            width="200"
                                            trigger="hover"
                                            content="スマートフォンから相続手続きで必要な書類をアップロードできます。"
                                            transition="el-zoom-in-bottom"
                                            popper-class="anken-tooltip"
                                            visible-arrow="false">
                                            <el-button class="btn button-color btn-table gtm_ankenmember_documents_m"
                                                       :class="isMobile ? 'el_mobile_button_right': ''" slot="reference">
                                                <span class="gtm_ankenmember_documents_m">スマホで<br/>書類提供</span>
                                            </el-button>
                                        </el-popover>
                                    </router-link>
                                </div>
                                <div class="div-update-notice">
                                    <router-link v-bind:to="'/estimation/' + data.id + '?type=qr'">
                                        <img height="12px" src="@/images/new.png"
                                             :class="noticeReportUpload[data.id] ? 'img-update-notice': 'img-update-notice-none'">
                                        <el-popover
                                            placement="top-start"
                                            title=""
                                            width="200"
                                            trigger="hover"
                                            content="入館証QRコードをご確認いただけます。"
                                            transition="el-zoom-in-bottom"
                                            popper-class="anken-tooltip"
                                            visible-arrow="false">
                                            <el-button class="btn button-color btn-table"
                                                       :class="isMobile ? 'el_mobile_button_left': ''" slot="reference">
                                                <div class="text-two-line">入館証QR</div>
                                            </el-button>
                                        </el-popover>
                                    </router-link>
                                </div>
                                <div class="div-update-notice">
                                    <router-link v-bind:to="'/estimation/' + data.id + '?type=report'">
                                        <img height="12px" src="@/images/new.png"
                                             :class="noticeReportUpload[data.id] ? 'img-update-notice': 'img-update-notice-none'">
                                        <el-popover
                                            placement="top-start"
                                            title=""
                                            width="200"
                                            trigger="hover"
                                            content="ご契約についての報告書をご確認いただけます。"
                                            transition="el-zoom-in-bottom"
                                            popper-class="anken-tooltip"
                                            visible-arrow="false">
                                            <el-button class="btn button-color btn-table"
                                                       :class="isMobile ? 'el_mobile_button_left': ''" slot="reference">
                                                <div class="text-two-line">報告書・請求書</div>
                                            </el-button>
                                        </el-popover>
                                    </router-link>
                                </div>
                                <div class="div-update-notice">
                                    <router-link v-bind:to="'/heritageDivision/' + data.id">
                                        <img height="12px" src="@/images/new.png"
                                             :class="isNoticeHeritageDivision == null && noticeHeritageDivision[data.id] || isNoticeHeritageDivision ? 'img-update-notice': 'img-update-notice-none'">
                                        <el-popover
                                            placement="top-start"
                                            title=""
                                            width="200"
                                            trigger="hover"
                                            content="実際の遺産価額から遺産分割のシミュレーションができます。"
                                            transition="el-zoom-in-bottom"
                                            popper-class="anken-tooltip"
                                            visible-arrow="false">
                                            <el-button class="btn button-color btn-table gtm_ankenmember_simulation_m"
                                                       :class="isMobile ? 'el_mobile_button_right': ''" slot="reference">
                                                <span class="gtm_ankenmember_simulation_m">遺産分割<br/>シミュレーション</span>
                                            </el-button>
                                        </el-popover>
                                    </router-link>
                                </div>
                                <div class="div-update-notice">
                                    <router-link v-bind:to="'/chat/' + data.id">
                                        <img height="12px" src="@/images/new.png"
                                             :class="noticeChat[data.id] ? 'img-update-notice': 'img-update-notice-none'">
                                        <el-popover
                                            placement="top-start"
                                            title=""
                                            width="200"
                                            trigger="hover"
                                            content="税理士法人レガシィの担当者とチャットができます。"
                                            transition="el-zoom-in-bottom"
                                            popper-class="anken-tooltip"
                                            visible-arrow="false">
                                            <el-button class="btn button-color btn-table gtm_ankenmember_hotline_m"
                                                       :class="isMobile ? 'el_mobile_button_left': ''" slot="reference">
                                                <span class="gtm_ankenmember_hotline_m">レガシィ<br/>ほっとライン</span>
                                            </el-button>
                                        </el-popover>
                                    </router-link>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
  </div>
  <div v-else-if="!this.isPortal || (isMobile && (this.isPortal || this.isAnken))">
      {{ this.displayMessage }}
  </div>
</template>

<script>
  import ApiAnken from '@/api/anken/anken-cl.js'
  import DocumentApi from '@/api/document/document.js'
  import UpdateNoticeApi from '@/api/update-notice/update-notice.js'
  import moment from 'moment'
  import { isMobile } from 'mobile-device-detect'

  export default {
    name: 'anken-info',
    props: {
      id: Number,
      isHideButton: Boolean,
      isNoticeHeritageDivision: {
        type: Boolean,
        require: false,
        'default': null
      },
      isPortal: Boolean,
      isAnken: Boolean
    },
    data () {
      return {
        isShowAnkenInfo: false,
        displayMessage: '　',
        tableData: [],
        isMobile: isMobile,
        noticeInvoiceFlag: {},
        noticeHeritageDivision: {},
        noticeReportUpload: {},
        noticeCamera: {},
        noticeChat: {},
        noticeSchedule: {}
      }
    },
    async mounted () {
      try {
        await this.loadAnken()
      } finally {
        this.$emit('ankenInfoLoad', true)
      }
    },
    methods: {
      async setUpdateNotice (anken) {
        const response = await UpdateNoticeApi.getMemberUpdateNotice(anken.id)
        if (response.status === 200) {
          let _this = this
          response.data.data.forEach(function (item) {
            switch (item.serviceName) {
              case 'invoiceFlag':
                _this.$set(_this.noticeInvoiceFlag, anken.id, true)
                break
              case 'heritageDivision':
                _this.$set(_this.noticeHeritageDivision, anken.id, true)
                break
              case 'reportUpload':
                _this.$set(_this.noticeReportUpload, anken.id, true)
                break
              case 'camera':
                _this.$set(_this.noticeCamera, anken.id, true)
                break
              case 'chat':
                _this.$set(_this.noticeChat, anken.id, true)
                break
              case 'schedule':
                _this.$set(_this.noticeSchedule, anken.id, true)
                break
            }
          })
        }
      },
      async loadAnken () {
        let response
        if (this.$route.name === 'portalMember') {
          response = await ApiAnken.getAnkenFilterList()
        } else {
          response = await ApiAnken.getAnkenList()
        }
        let self = this
        let ankens = response.data
        if (ankens.length > 0) {
          this.isShowAnkenInfo = true
          const ankenFind = ankens.find(a => a.id === this.id)
          if (ankenFind) {
            const res = await DocumentApi.getPublishFile(ankenFind.id)
            ankenFind.scheduleFileName = res.data.data ? res.data.data.fileName : null
            self.tableData = [ankenFind]
            self.setUpdateNotice(ankenFind)
            localStorage.setItem('ankenInfo', JSON.stringify(ankenFind))
          } else {
            const documents = ankens.map(ak => {
              return DocumentApi.getPublishFile(ak.id).then(res => ({
                ankenId: ak.id,
                scheduleFileName: res.data.data ? res.data.data.fileName : null
              }))
            })
            await Promise.all(documents).then(dc => {
              for (const anken of ankens) {
                const schedule = dc.find(d => d.ankenId === anken.id)
                anken.scheduleFileName = schedule.scheduleFileName
                self.tableData.push(anken)
                self.setUpdateNotice(anken)
              }
            })
          }
        } else if (!this.isPortal || (this.isMobile && (this.isPortal || this.isAnken))) {
          if (this.isMobile && this.isPortal) {
            this.$emit('updateHasAnken', false)
          }
          this.displayMessage = 'ご依頼はありません'
        }
      },
      formatDate (date, format = 'YYYY年MM月DD日 (ddd)', defaultValue = null) {
        if (date !== null) {
          return moment.parseZone(date).locale('ja').format(format)
        } else {
          return defaultValue
        }
      },
      getMemberName (heir) {
        let prefix = heir.primaryHeir ? '(代)' : '(相)'
        let name = heir.member.lastName + ' ' + heir.member.firstName
        return prefix + ' ' + name
      },
      scrollFile (id) {
        this.$set(this.noticeSchedule, id, false)
        this.$emit('scrollFileData')
      },
      handleShowExplanation () {
        this.$emit('showExplanation')
      }
    }
  }
</script>

<style scoped>
  .link-to-document {
    text-decoration: underline;
    color: blue;
  }
  .el-table__header .has-gutter th{
    background: #c0b283;
    color: #000000;
    font-weight: bold;
  }
  .el-table__body tbody tr{
    color: #000000;
  }
  .el-table--border td{
    border-right: 1px solid #e5dec6;
  }
  .el-table--border th,
  .el-table td, .el-table th.is-leaf {
    border-right: 1px solid #e5dec6;
  }
  .btn-list {
    margin-top: 30px;
  }
  .btn-list button{
    /*padding: 5px;*/
    margin: 5px 10px 5px 0px;
  }
  .data-content-anken {
    padding-bottom: 50px;
  }
  .btn-list a {
    color: #ffffff;
  }
  .anken-info .btn-table {
    width: 150px;
  }
  .anken-info .btn-table a {
    font-size: 15px !important;
  }
  .div-update-notice {
      display:inline-block;
      position: relative;
  }
  .div-update-notice-schedule {
      display:inline;
      position: relative;
  }
  .img-update-notice {
      position: absolute;
      left:6px;
  }
  .img-update-notice-schedule {
      position: absolute;
      left:-4px;
      top:-12px;
  }
  .img-update-notice-none {
      display:none;
  }

  .text-two-line {
      height: 2em;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 25px;
  }
  .table-responsive {
      border: 1px solid #d6d6d6;
      padding: 15px;
  }
  table tr td {
      background:  #fffdf7 !important;
  }
  table td, table th  {
      vertical-align: middle !important;
  }
  table td .content {
      text-align: left;
  }
  table td .content img {
      width: 100%;
      height: 150px;
  }
  table tr td a {
      color: #3a8ee6 !important;
  }
  table {
      width: 100%;
      margin: 1em auto;
      /*border: 2px solid #d6d6d6;*/
      border-collapse: separate !important;
      /*-webkit-box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);*/
      /*-moz-box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);*/
      /*box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);*/
  }
  table tr:not(:last-child) td {
      border-bottom: unset !important;
  }
  table tr:last-child td {
      padding-left: unset !important;
      padding-right: unset !important;
  }
  .table td {
      text-align: center;
      padding: 10px;
      /*background: #e6f6fe;*/
      font-size: 14px;
  }
  .table .bg-blue td {
      background: #8edbff;
  }
  .table .bg-lightblue td {
      background: #e6f6fe;
  }
  .table th {
      border-bottom: 5px solid #ff9900;
      text-align: center;
      background-color: #fffaf0;
      padding: 10px;
      font-size: 16px;
      font-weight: bold;
      color: #321007;
  }
  .table-responsive {
      border-radius: unset;
  }
  table tr.empty-data td {
      padding: 0 !important;
  }
  .table {
      border-radius: unset !important;
  }
  .table thead th + th{
      border-left: 1px solid #d6d6d6 !important;
  }
  .table tr {
      background-color: #fffafa !important;
  }
  .table td {
      background-color: #fffafa !important;
  }
  .table tbody td + td {
      border-left: 1px solid #d6d6d6 !important;
  }
  .table thead + tbody td {
      border-top: 1px solid #d6d6d6 !important;
  }
  @media screen and (max-width: 480px){
      .btn-list  button {
          margin-right: 5px;
          margin-bottom: unset;
      }
  }
</style>

<style>
    @import "../../../../assets/css/client_custom.css";
</style>
